{
  "common": {
    "yes": "Yes",
    "no": "No",
    "next": "Next",
    "previous": "Previous",
    "submit": "Submit",
    "actions": "Actions",
    "noData": "No data",
    "filters": "Filters",
    "page": "Page",
    "otherInputPlaceholder": "Please specify...",
    "otherAnswerLabel": "Other answer",
    "otherNumberPlaceholder": "Enter number...",
    "performingAction": "Performing action...",
    "otherNumericInputLabel": "Number of users affected by the incident",
    "errors": {
      "email": "Field must be a valid email address",
      "minlength": "Field must be minimum {{requiredLength}} characters long. Current length is {{actualLength}}",
      "required": "Field is required",
      "maxlength": "Field must be maximum {{requiredLength}} characters. Current length is {{actualLength}}",
      "pattern": "Field must match pattern {{requiredPattern}}",
      "min": "Field must be minimum {{min}}",
      "max": "Field must be maximum {{max}}",
      "websitePattern": "Please enter a valid website URL (e.g., https://example.com)",
      "durationPattern": "Please enter a valid duration in format {{durationLabel}}",
      "pageNotFound": "No form was found",
      "pageNotFoundDescription": "No active forms exist. Please, try again later or contact support.",
      "startsWith": "Field must start with {{startsWith}} and contain only digits",
      "minDate": "Date must be after {{minDate}}",
      "maxDate": "Date must be before {{maxDate}}",
      "step": "Field must be a multiple of {{step}}",
      "mustMatchPassword": "Passwords do not match",
      "strongPassword": "Password must be at least 8 characters long, contain at least one uppercase letter, one lowercase letter, one number, and one special character"
    },
    "enums": {
      "incidentStatus": {
        "status": "Status",
        "REPORTED": "Incident reported",
        "REPORT_SUBMITTED": "Delivered additional notice",
        "ADDITIONAL_REPORT_SUBMITTED": "Additional report submitted",
        "CLOSED": "Closed",
        "DISMISSED": "Dismissed"
      },
      "mediaType": {
        "UNKNOWN": "Unknown",
        "IMAGE": "Image",
        "VIDEO": "Video",
        "SVG": "SVG",
        "AUDIO": "Audio",
        "PDF": "PDF",
        "WORD": "Word Document",
        "ARCHIVE": "Archive"
      }
    },
    "reportType": {
      "title": "What are you reporting?",
      "description": "Choose the type of report to open the matching form.",
      "incident": "Incident",
      "incidentDescription": "An incident that occurred in the ICT system.",
      "avoided": "Avoided incident",
      "avoidedDescription": "An incident that was prevented before it happened.",
      "change": "Change report type",
      "downloadPdf": "Download PDF form"
    }
  },
  "toast": {
    "success": "Success",
    "warning": "Warning",
    "error": "Error",
    "languageChanged": "Language changed"
  },
  "auth": {
    "forgotPassword": "Forgot password?",
    "login": "Login",
    "returnToLogin": "Return to login",
    "sendEmail": "Send email",
    "resetPassword": "Reset password",
    "register": "Register",
    "alreadyHaveAccount": "Already have an account?",
    "otpCode": "OTP Code",
    "otpExpiresIn": "Expires in",
    "otpExpired": "OTP expired, please try again",
    "setPassword": {
      "title": "Set a new password",
      "description": "Choose your own password to continue. You will then sign in again with it.",
      "submit": "Save password",
      "signOut": "Sign out"
    },
    "fields": {
      "name": "Name",
      "email": "Email",
      "password": "Password",
      "newPassword": "New password",
      "repeatPassword": "Repeat password"
    }
  },
  "sidebar": {
    "reportIncident": "Report Incident",
    "signOut": "Sign Out",
    "viewReportedIncidents": "View reported incidents",
    "editProfile": "View Profile",
    "avoidedIncidents": "Avoided incidents overview"
  },
  "languagePicker": {
    "en": "English",
    "sr": "Srpski (latinica)",
    "cyr": "Српски (ћирилица)"
  },
  "languages": {
    "en": "English",
    "sr": "Serbian (latin)",
    "cyr": "Serbian (cyrillic)"
  },
  "submittedForms": {
    "single": {
      "noFields": "No fields to display"
    }
  },
  "confirmations": {
    "delete": "Delete this item?",
    "submitForm": "Are you sure you want to submit the form?"
  },
  "primeng": {
    "multiselect": {
      "selectedItemsLabel": "{0} items selected"
    }
  },
  "buttons": {
    "no": "Cancel",
    "yes": "Confirm"
  }
}
